import script from "./Coreniopage.vue?vue&type=script&setup=true&lang=js"
export * from "./Coreniopage.vue?vue&type=script&setup=true&lang=js"

import "./Coreniopage.vue?vue&type=style&index=0&id=e7fdbfbe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7fdbfbe"]])

export default __exports__